import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { groqQueryOptions } from "../../shared/utils/groqQueryOptions"
import { complaintProjectionForTable } from "../sanity/complaint.projection"

/**
 * Query complaints that will be displayed in the table
 */
export const queryComplaints = {
  async complaints(_parent, args, context, _info) {
    const {
      cdn = false,
      lang = AppSettings.defaultLocale(),
      offset,
      limit,
      sort,
      sortWithinLimits,
      year,
      defectId,
      customerNumber,
    } = args
    const { user } = context
    const client = context.sanityClient
    const config = AppSettings.sanityConfigByLang(lang)
    client.config({ ...config, useCdn: cdn })

    await checkPermissions({
      user,
      domainObject: DomainObjects.COMPLAINTS,
      operation: Operations.READ,
    })

    if (customerNumber) {
      await validateAccessRightsToCustomer({
        user: user,
        customerNumber: customerNumber,
      })
    }

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    const yearDate = new Date(year)
    const nextYearDate = new Date((Number(year) + 1).toString())
    const yearFilter = year
      ? `&& creationAt >= "${yearDate.toISOString()}" && creationAt < "${nextYearDate.toISOString()}"`
      : ""

    const customerNumberFilter = customerNumber ? `&& customerNumber=="${customerNumber}"` : ""

    const defectFilter = defectId ? `&& "${defectId}" in defects[]._ref` : ""

    const complaints = await client.fetch(
      groq`{
          "total": count(*[_type=="complaint" ${yearFilter}${defectFilter}${customerNumberFilter}${draftsFilter}]),
          "items": *[_type=="complaint" ${yearFilter}${defectFilter}${customerNumberFilter}${draftsFilter}]${pipesAndLimits} {
            ${complaintProjectionForTable()}
          }
        }`,
    )

    if (complaints?.items && complaints?.items?.length !== 0) {
      const { items, total } = complaints
      return {
        total,
        items,
      }
    }

    return null
  },
}
